<div mat-dialog-title>
	<span translate>elink.contact-mill</span>
</div>
<form [formGroup]="elinkForm" (ngSubmit)="sendMessage(elinkForm)">
	<div mat-dialog-content class="elink-container">
		<div class="elink-data-row">
			<span class="elink-data-row-label" translate>elink.from</span>
			<span class="elink-data-row-value">{{gender}} {{lastname}} {{firstname}} ({{email}})</span>
		</div>
		<div [class.copyto-input-error]="elinkForm.controls['copyTo'].invalid && elinkForm.controls['copyTo'].touched"
			class="elink-data-row elink-dark-theme elink-lower-input">
			<mat-form-field>
				<mat-label translate>elink.copy-to</mat-label>
				<input class="elink-dark-theme-line" type="text" matInput spellcheck="false" autocomplete="off"
						formControlName="copyTo">
				<mat-error translate>elink.invalid-email-format</mat-error>
			</mat-form-field>
		</div>
		<div class="elink-data-row">
			<mat-form-field class="subject-input" floatLabel="always">
				<mat-label translate>elink.subject</mat-label>
				<div class="subject-input-text">
					<span>{{ subject }}&nbsp;</span>
					<input matInput #subjectInput
							type="text"
							formControlName="messageSubject">
				</div>
			</mat-form-field>
		</div>
		<div class="elink-data-row">
			<span class="elink-data-row-label" translate>elink.data-automatically-sent-with-the-mail</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>order.customer.order.number</span>
			<span class="elink-multi-data-row-value"> {{data.customerOrderNumber}}/{{data.customerOrderItemNumber}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>order.supplier.order.number</span>
			<span class="elink-multi-data-row-value"> {{data.supplierOrderNumber}}/{{data.supplierOrderItemNumber}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>order.mill.order.number</span>
			<span class="elink-multi-data-row-value"> {{data.millOrderNumber}}/{{data.millOrderItemNumber}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>order.mill</span>
			<span class="elink-multi-data-row-value"> {{data.mill}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>batch.card.customer</span>
			<span class="elink-multi-data-row-value"> {{customer}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label elink-multi-data-row-label-center"
				translate>order.card.product</span>
			<div class="elink-multi-data-row-value">
				<div>
					<span class="bold" translate>elink.category</span>
					<span class="double-info">{{data.productCategory}}</span>
				</div>
				<div>
					<span class="bold" translate>elink.dimension</span>
					<span class="double-info">{{ data | copoDimension }}</span>
				</div>
			</div>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>order.ordered</span>
			<span class="elink-multi-data-row-value">{{data.orderedQuantity | copoNumber: 'weight':'t'}}</span>
		</div>
		<div class="elink-multi-data-block">
			<span class="elink-multi-data-row-label" translate>filter.cdd</span>
			<span class="elink-multi-data-row-value">{{ data.cdd ? (data.cdd | copoDate:'week') : UNDERSCORE }}</span>
		</div>
		<div [class.comment-input-error]="elinkForm.controls['textMessage'].touched &&
					elinkForm.controls['textMessage'].invalid"
			class="elink-data-row elink-margin-message elink-dark-theme elink-lower-input">
			<mat-form-field>
				<mat-label translate>elink.comment</mat-label>
				<textarea rows="3" class="textarea-no-resize" type="textarea"
						formControlName="textMessage"
						matInput spellcheck="false" autocomplete="off"></textarea>
				<mat-error *ngIf="elinkForm.controls['textMessage'].touched &&
					elinkForm.controls['textMessage'].invalid"
							translate>elink.comment-is-required</mat-error>
			</mat-form-field>
		</div>
		<div class="upload-files">
			<button type="button" mat-button class="elink-add-attachment" (click)="fileInput.click()">
				<mat-icon svgIcon="add"></mat-icon>
				<span class="elink-add-attachment-label" translate>elink.add.attachment</span>
			</button>
			<div class="uploadfilecontainer" copoAppDragDropFiles (fileDropped)="uploadFile($event)">
				<span class="uploadfilecontainer-label">Drag and drop your files here</span>
				<input hidden type="file" id="files" #fileInput (change)="uploadFile(fileInput.files)">
			</div>
		</div>
		<div class="files-list">
			<a class="file-item" *ngFor="let file of files;let i= index"
				[href]="getFileUrl(file) | copoSafeUrl"
				target="_blank"
				rel="noopener"
				(click)="showFile($event, file)">
				<mat-icon class="file-item-icon" svgIcon="table_document"></mat-icon>
				<span class="elink-item-text">{{ file.name }}</span>
				<mat-icon class="file-item-delete-icon" svgIcon="delete"
						(click)="deleteAttachment(i);$event.preventDefault();$event.stopPropagation();"></mat-icon>
			</a>
		</div>
	</div>
	<div mat-dialog-actions class="elink-save-cancel-button-block-confirmation elink-save-cancel">
		<div class="elink-save-cancel-button-container">
			<button (click)="onCancelClick()" mat-button type="button" class="elink-customize-button">
				<span translate>dashboard.cancel</span>
			</button>
			<button mat-raised-button color="primary" type="submit" *ngIf="elinkForm" [disabled]="!elinkForm.valid">
				<span translate>elink.send</span>
			</button>
		</div>
	</div>
</form>
